var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$props.itemDetail.componentSubcode === "fp_1"
      ? _c(
          "div",
          _vm._l(_vm.dataList, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c("el-image", {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    display: "block",
                  },
                  attrs: {
                    src: item.bannerPic
                      ? item.bannerPic
                      : require("@/assets/customPage/" +
                          _vm.$props.itemDetail.componentSubcode +
                          "_" +
                          (index + 1) +
                          ".png"),
                    fit: "cover",
                  },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "fp_l1_r1"
      ? _c("div", [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("el-image", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      display: "block",
                    },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/" +
                            _vm.$props.itemDetail.componentSubcode +
                            "_" +
                            (index + 1) +
                            ".png"),
                      fit: "cover",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "fp_3"
      ? _c("div", [
          _c(
            "div",
            {
              staticStyle: { display: "flex", "justify-content": "flex-start" },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { width: "33.3%" } },
                [
                  _c("el-image", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      display: "block",
                    },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/" +
                            _vm.$props.itemDetail.componentSubcode +
                            "_" +
                            (index + 1) +
                            ".png"),
                      fit: "cover",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "fp_4"
      ? _c("div", [
          _c(
            "div",
            {
              staticStyle: { display: "flex", "justify-content": "flex-start" },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { width: "25%" } },
                [
                  _c("el-image", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      display: "block",
                    },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/" +
                            _vm.$props.itemDetail.componentSubcode +
                            "_" +
                            (index + 1) +
                            ".png"),
                      fit: "cover",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "fp_5"
      ? _c("div", [
          _c(
            "div",
            {
              staticStyle: { display: "flex", "justify-content": "flex-start" },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "div",
                { key: index, staticStyle: { width: "20%" } },
                [
                  _c("el-image", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      display: "block",
                    },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/" +
                            _vm.$props.itemDetail.componentSubcode +
                            "_" +
                            (index + 1) +
                            ".png"),
                      fit: "cover",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "fp_l1_r2"
      ? _c("div", [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                _vm._l(
                  _vm.dataList.filter(function (m, n) {
                    return n === 0
                  }),
                  function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { width: "100%" } },
                      [
                        _c("el-image", {
                          staticStyle: {
                            width: "100%",
                            height: "76px",
                            display: "block",
                          },
                          attrs: {
                            src: item.bannerPic
                              ? item.bannerPic
                              : require("@/assets/customPage/" +
                                  _vm.$props.itemDetail.componentSubcode +
                                  "_" +
                                  (index + 1) +
                                  ".png"),
                            fit: "cover",
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                _vm._l(
                  _vm.dataList.filter(function (m, n) {
                    return n > 0
                  }),
                  function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { width: "100%" } },
                      [
                        _c("el-image", {
                          staticStyle: {
                            width: "100%",
                            height: "38px",
                            display: "block",
                          },
                          attrs: {
                            src: item.bannerPic
                              ? item.bannerPic
                              : require("@/assets/customPage/" +
                                  _vm.$props.itemDetail.componentSubcode +
                                  "_" +
                                  (index + 2) +
                                  ".png"),
                            fit: "cover",
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "fp_l2_r1"
      ? _c("div", [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                _vm._l(
                  _vm.dataList.filter(function (m, n) {
                    return n <= 1
                  }),
                  function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { width: "100%" } },
                      [
                        _c("el-image", {
                          staticStyle: {
                            width: "100%",
                            height: "38px",
                            display: "block",
                          },
                          attrs: {
                            src: item.bannerPic
                              ? item.bannerPic
                              : require("@/assets/customPage/" +
                                  _vm.$props.itemDetail.componentSubcode +
                                  "_" +
                                  (index + 1) +
                                  ".png"),
                            fit: "cover",
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                _vm._l(
                  _vm.dataList.filter(function (m, n) {
                    return n > 1
                  }),
                  function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { width: "100%" } },
                      [
                        _c("el-image", {
                          staticStyle: {
                            width: "100%",
                            height: "76px",
                            display: "block",
                          },
                          attrs: {
                            src: item.bannerPic
                              ? item.bannerPic
                              : require("@/assets/customPage/" +
                                  _vm.$props.itemDetail.componentSubcode +
                                  "_" +
                                  (index + 3) +
                                  ".png"),
                            fit: "cover",
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "fp_l1_r3"
      ? _c("div", [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                _vm._l(
                  _vm.dataList.filter(function (m, n) {
                    return n === 0
                  }),
                  function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { width: "100%" } },
                      [
                        _c("el-image", {
                          staticStyle: {
                            width: "100%",
                            height: "76px",
                            display: "block",
                          },
                          attrs: {
                            src: item.bannerPic
                              ? item.bannerPic
                              : require("@/assets/customPage/" +
                                  _vm.$props.itemDetail.componentSubcode +
                                  "_" +
                                  (index + 1) +
                                  ".png"),
                            fit: "cover",
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "50%" } },
                [
                  _vm._l(
                    _vm.dataList.filter(function (m, n) {
                      return n === 1
                    }),
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticStyle: { width: "100%" } },
                        [
                          _c("el-image", {
                            staticStyle: {
                              width: "100%",
                              height: "38px",
                              display: "block",
                            },
                            attrs: {
                              src: item.bannerPic
                                ? item.bannerPic
                                : require("@/assets/customPage/" +
                                    _vm.$props.itemDetail.componentSubcode +
                                    "_" +
                                    (index + 2) +
                                    ".png"),
                              fit: "cover",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-start",
                      },
                    },
                    _vm._l(
                      _vm.dataList.filter(function (m, n) {
                        return n > 1
                      }),
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticStyle: { width: "50%" } },
                          [
                            _c("el-image", {
                              staticStyle: { width: "100%", display: "block" },
                              attrs: {
                                src: item.bannerPic
                                  ? item.bannerPic
                                  : require("@/assets/customPage/" +
                                      _vm.$props.itemDetail.componentSubcode +
                                      "_" +
                                      (index + 3) +
                                      ".png"),
                                fit: "cover",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ],
                2
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }